export type CrmMode = "placement-only" | "home-care-only" | "combined" | "none";

export interface CrmModeInfo {
    mode: CrmMode;
    placementEnabled: boolean;
    homeCareEnabled: boolean;
}

export const resolveCrmMode = (
    placementEnabled: boolean,
    homeCareEnabled: boolean,
): CrmMode => {
    if (placementEnabled && homeCareEnabled) return "combined";
    if (placementEnabled) return "placement-only";
    if (homeCareEnabled) return "home-care-only";
    return "none";
};

export const placementClientsSettingsLabel = (mode: CrmMode): string =>
    mode === "combined" ? "Clients - Placement" : "Clients";

export const homeCareClientsSettingsLabel = (mode: CrmMode): string =>
    mode === "combined" ? "Clients - Home Care" : "Clients";
